'use strict';
/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    collectionSS22Init();
});

function collectionSS22Init() {
    // init carousel with special title swipe in the top
    var $collection2Carousel = $('#js-collection2Carousel'),
        $collection2BookmarksWrapper = $('.js-collection2Bookmarks'),
        $allCollection2Bookmarks = $collection2BookmarksWrapper.find('.js-collection2Bookmark'),
        amountCollection2Bookmarks = $allCollection2Bookmarks.length;

    // sync slick with title panel
    $collection2Carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var $slide = $allCollection2Bookmarks.filter('[data-index=' + nextSlide + ']');

        $allCollection2Bookmarks.removeClass('active').addClass('hidden');

        // scroll next
        if (nextSlide > currentSlide) {
            // the last slide should be active
            if (nextSlide === (amountCollection2Bookmarks - 1)) {
                $slide.prev().removeClass('hidden');
                $slide.addClass('active').removeClass('hidden');
            }
            else {
                $slide.prev().addClass('hidden');
                $slide.addClass('active').removeClass('hidden');
                $slide.next().removeClass('hidden');
            }
        }
        // scroll prev
        else {
            // the first slide should be active
            if (nextSlide === 0) {
                $slide.addClass('active').removeClass('hidden');
                $slide.next().removeClass('hidden');
            }
            else {
                $slide.prev().removeClass('hidden');
                $slide.addClass('active').removeClass('hidden');
                $slide.next().addClass('hidden');
            }
        }
    });

    $collection2Carousel.slick({
        enable: true,
        slidesToShow: 1,
        infinite: false,
        appendArrows: '#js-collection2CarouselArrows'
    });
}
